module.exports = __webpack_public_path__ + "img/publicSuccess.ca4fe820.svg";